import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import ClassEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ProjectKpisModal = ({
  kpiModal,
  setKpiModal,
  handleCreateKpi,
  projectID,
  goalID,
  objectiveID,
}) => {
  const [state, setState] = useState("");

  const handleClick = () => {
    const data = {
      name: state,
      project_id: projectID,
      goal_id: goalID,
      objective_id: objectiveID,
    };
    handleCreateKpi(data);
    setState("");
    setKpiModal(false);
  };

  return (
    <Dialog
      open={kpiModal}
      TransitionComponent={Transition}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle
        sx={{
          color: "purple",
          textTransform: "uppercase",
          fontWeight: "600",
          textDecoration: "underline",
        }}
      >
        Add New KPI
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            width: 500,
            maxWidth: "100%",
            marginTop: "10px",
          }}
        >
          <CKEditor
            className="form-control"
            editor={ClassEditor}
            data={state}
            onChange={(event, editor) => {
              const data = editor.getData();
              setState(data);
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClick} variant="contained" color="secondary">
          create Kpi
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => setKpiModal(false)}
        >
          cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectKpisModal;
